import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/dashboard", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        setError(
          e?.response?.data?.detail || "Sign-in could not be completed. Please try again."
        );
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      {error ? (
        <>
          <p className="max-w-md font-semibold text-[#a10000]">{error}</p>
          <a href="/dashboard" className="bg-[#244aa2] px-6 py-3 text-[12px] font-bold uppercase tracking-wide text-white">
            Back to sign in
          </a>
        </>
      ) : (
        <>
          <Loader2 className="h-8 w-8 animate-spin text-[#244aa2]" />
          <p className="text-sm font-semibold text-[#575757]">Completing secure sign-in…</p>
        </>
      )}
    </div>
  );
}
